import React from "react";
import { useTranslation } from "react-i18next";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { format, parse } from "date-fns";

type GraphicsProps = {
  data:
    | {
        date: string;
        delivered: number;
        // cancelled: number;
      }[]
    | never[];
  width?: string | number | undefined;
  height?: string | number | undefined;
};

const GraphicsOrders = ({ data, width, height }: GraphicsProps) => {
  const { t } = useTranslation();
  return (
    <ResponsiveContainer width={width} height={height}>
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 10,
          right: 0,
          left: -15,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey="date"
          tickFormatter={(date) => {
            const dateFormat = parse(
              date?.split("T")?.[0],
              "yyyy-MM-dd",
              new Date(),
            );

            return format(dateFormat, "dd/MM");
          }}
        />
        <YAxis type="number" scale="auto" />
        <Tooltip
          formatter={(value, name) => [value, t(name.toString())]}
          labelFormatter={(label) => {
            const date = parse(
              label?.split("T")?.[0],
              "yyyy-MM-dd",
              new Date(),
            );

            return format(date, "dd/MM/yyyy");
          }}
        />
        <Bar dataKey="delivered" stackId="orders" fill="#000" />
        {/* <Bar dataKey="cancelled" stackId="orders" fill="#9847F5" /> */}
      </BarChart>
    </ResponsiveContainer>
  );
};

export default GraphicsOrders;
